
class Rotator {
  constructor(container) {
    this.container = container;
    this.currentIndex = 0;
    this.bgImages = container.querySelectorAll('.hero-bg-image');
    this.indicators = container.querySelectorAll('.indicator-dot');
    this.totalItems = this.bgImages.length;

    this.init();
  }

  init() {
    if (this.totalItems > 0) {
      this.showCurrentItem();
      this.setupEventListeners();
    }
  }

  showCurrentItem() {
    this.bgImages.forEach((image, index) => {
      image.classList.toggle('active', index === this.currentIndex);
    });
    
    if (this.indicators.length > 0) {
      this.indicators.forEach((indicator, index) => {
        indicator.classList.toggle('active', index === this.currentIndex);
      });
    }
  }

  setupEventListeners() {
    const nextButton = this.container.querySelector('.arrow-right');
    const prevButton = this.container.querySelector('.arrow-left');

    if (nextButton) {
      nextButton.addEventListener('click', () => this.next());
    }
    if (prevButton) {
      prevButton.addEventListener('click', () => this.prev());
    }
    
    this.indicators.forEach((indicator, index) => {
      indicator.addEventListener('click', () => {
        this.currentIndex = index;
        this.showCurrentItem();
      });
    });
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.totalItems;
    this.showCurrentItem();
  }

  prev() {
    this.currentIndex = (this.currentIndex - 1 + this.totalItems) % this.totalItems;
    this.showCurrentItem();
  }
}

let rotatorInstance = null;

function initializeRotator() {
  const heroSection = document.querySelector('.hero-section-bg');
  if (heroSection) {
    rotatorInstance = new Rotator(heroSection);
  }
  return rotatorInstance;
}

export { rotatorInstance, initializeRotator };

if (typeof window !== 'undefined') {
  window.LastagRotator = Rotator;
  window.initializeRotator = initializeRotator;
}